<template>
  <div>
    <div class="content-header">
      <div class="title-container">
        <div class="left-title">
          <SGPRowComponent>
            <SGPColComponent cols="5">
              <span class="page-title">
                {{ dadosFichaTecnica.pco_workflow?.ctrl_workflow?.workflow }}
              </span>
            </SGPColComponent>
            <SGPColComponent cols="5">
              <a target="_blank"
                style="margin: 3px; padding: 5px 8px; border-radius: 8px; background-color: #444; font-size: 14px; color: #fff; text-decoration: none; font-weight: bold"
                :href="`http://star21ebt/star21/circuitos/fraHeaderCircuito_alterado.asp?cod_cir=${circuitoSelecionado.cod_cir}`">
                <span class="text-white">CIR {{ circuitoSelecionado.cod_cir }}/{{ circuitoSelecionado.ponta }}</span>
              </a>
              <!-- <SGPFormBotaoComponent
              round
              small
              :color="corMultaVencida(circuitoSelecionado.data_prometida)"
              v-if="circuitoSelecionado.possui_multa"
              @click="abrirModalMulta = !abrirModalMulta"
              style="margin: 3px;"
              >
              <span class="text-white">Multa - {{ circuitoSelecionado.data_prometida | formataDataPrometida }}</span>
            </SGPFormBotaoComponent> -->
              <SGPFormBotaoComponent round small v-if="circuitoSelecionado.solicitacao_cancelamento"
                :color="['primary', 'orange']" :key="alertaSolicitacaoCancelamento" style="margin: 3px;">
                <span class="text-white">Aviso Cancelamento</span>
              </SGPFormBotaoComponent>

              <SGPFormBotaoComponent round small :color="'#00818F'" v-if="circuitoSelecionado.ctrl_projeto_id"
                @click="abrirModalProjeto = !abrirModalProjeto" style="margin: 3px;">
                <span class="text-white">{{ circuitoSelecionado.ctrl_projeto.projeto }}</span>
              </SGPFormBotaoComponent>

              <!-- <SGPFormBotaoComponent
              color="primary"
              x-small
              fab
              v-if="circuitoSelecionado.solicitacao_mob"
              @click="abrirSolicitacaoMobilidade = !abrirSolicitacaoMobilidade"
              style="margin: 3px;"
            >
              <v-icon
                color="white"
              >mdi-page-next-outline</v-icon>
            </SGPFormBotaoComponent> -->
            </SGPColComponent>

            <SGPColComponent cols="2">
              <!-- <SGPFormBotaoComponent
              color="orange"
              round
              link
              small
              :href="`/sgp/ficha-tecnica/${$route.params.pco_tarefa_id}`"
              style="margin: 3px;"
            >
              Ficha Tecnica
            </SGPFormBotaoComponent> -->

              <!-- <SGPFormBotaoComponent
              color="secondary"
              x-small
              fab
              @click="abrirModalImage = true"
              :disabled="tarefaSelecionada.ctrl_tarefa.url_file_processo ? false : true"
              style="margin: 3px;"
            >
              <v-icon
                color="white"
              >mdi-image</v-icon>
            </SGPFormBotaoComponent> -->
            </SGPColComponent>
          </SGPRowComponent>
        </div>
      </div>
      <!-- INICIO BUTTONS-->
      <div class="buttons-container mt-3">
        <!-- <SGPFormBotaoComponent
          text
          @click="abrirModalChecklistAgendamento = true"
          v-if="$permissionamento.possuiPermissao('gestao-producao.pco-check-agend-envio-email')"
        >
          <v-icon color="red" >mdi-calendar-blank-outline</v-icon>
          <span>Checklist Agendamento</span>
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent
          @click="abrirModalOrdemServico = true"
          text
          v-if="$permissionamento.possuiPermissao('gestao-producao.modos.aberturaDeOs')"
        >
          <v-icon color="red" >mdi-format-list-checks</v-icon>
          <span>Modos</span>
        </SGPFormBotaoComponent> -->

        <!-- <SGPFormBotaoComponent
          text
          v-if="$permissionamento.possuiPermissao('gestao-producao.wf1.aberturaDeOsWf1')"
          @click="abrirModalWf1 = true"
        >
          <v-icon color="red" >mdi-calendar-edit-outline</v-icon>
          <v-badge
            v-if="dadosWf1PcoCircuito.length"
            :content="dadosWf1PcoCircuito.length"
            class="badge-anotacoes mb-7"
            style="position: absolute; left: 18px;"
          ></v-badge>
          <span>WF1</span>
        </SGPFormBotaoComponent> -->

        <!-- <SGPFormBotaoComponent
          @click="abrirModalConsulta = true"
          text
          v-if="$permissionamento.possuiPermissao('gestao-producao.modos.aberturaDeOs')"
        >
          <v-icon color="red" > mdi-account-search </v-icon>
          <span>Consulta </span>
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent
          text
          @click="listarTratativasSemTratamento(); abrirModalSemTratamento = true"
          v-if="$permissionamento.possuiPermissao('gestao-producao.tratativas-sem-tratamento.listar')"
        >
          <v-icon color="red" >mdi-format-list-checks</v-icon>
          <span>Atualização</span>
        </SGPFormBotaoComponent> -->

        <!-- <SGPFormBotaoComponent
          v-if="listaDePcoCircuitoAnotacoes.length"
          text @click="abrirModalAnotacao = true">
          <v-icon color="red">mdi-format-list-checks</v-icon>
          <v-badge
            v-if="listaDePcoCircuitoAnotacoes.length"
            :content="listaDePcoCircuitoAnotacoes.length"
            class="badge-anotacoes mb-7"
            style="position: absolute; left: 18px;"
          ></v-badge>
          <span>Anotações</span>
        </SGPFormBotaoComponent> -->

        <SGPFormBotaoComponent text link :to="getLinkFilaTarefas()">
          <v-icon color="red">mdi-list-box-outline</v-icon>
          <span>Filas Tarefas</span>
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent text color="primary" link to="/workflow/backlog">
          <v-icon color="primary">mdi-cursor-default-click-outline</v-icon>
          <span>Meus Atendimentos</span>
        </SGPFormBotaoComponent>
      </div>

    </div>

    <div class="content-body mt-4">
      <div class="card-infor-wrapper d-flex justify-content-spacebetween">
        <SGPInfoCardComponent>
          <span class="grey--text font-size-14 mr-2 w-500">Serviço:</span>
          <span class="primary--text font-size-18 text-capitalize">
            <strong>{{ circuitoSelecionado.star21_servico?.servico || '-' }}</strong>
          </span>
        </SGPInfoCardComponent>

        <SGPInfoCardComponent>
          <span class="grey--text font-size-14 mr-2 w-500">Ação:</span>
          <span class="primary--text font-size-18 text-capitalize">
            <strong>{{ circuitoSelecionado.star21_acao?.acao || '-' }}</strong>
          </span>
        </SGPInfoCardComponent>

        <SGPInfoCardComponent>
          <span class="grey--text font-size-14 mr-2 w-500">Status:</span>
          <span class="primary--text font-size-18 text-capitalize">
            <strong v-if="dadosFichaTecnica.pco_tarefa?.finalized_at == null">
              {{ dadosFichaTecnica.pco_tarefa?.status_atual?.ctrl_status?.status || '-' }}
            </strong>
            <strong v-else>Concluída</strong>
          </span>
        </SGPInfoCardComponent>

        <SGPInfoCardComponent>
          <span class="grey--text font-size-14 mr-2 w-500">Designação:</span>
          <span class="primary--text font-size-18 text-capitalize">
            <strong>{{ circuitoSelecionado.terminal || circuitoSelecionado.designacao || '-' }}</strong>
          </span>
        </SGPInfoCardComponent>
      </div>

      <div class="mt-5">
        <v-card class="d-flex pt-2 pb-2">
          <div class="card-sla">
            <strong>{{ circuitoSelecionado.ctrl_tipo_circuito_sla?.tipo || '-' }}</strong>
          </div>

          <div class="card-sla">
            <div>
              <span class="title">
                {{ tarefaSelecionada.status_atual?.aging_dias_formatado || '-' }}
                {{ getAgingTarefa || '' }}
              </span>
              <span class="sub-title">aging tarefa</span>
            </div>
            <div>
              <span class="sla">
                SLA
                <v-icon :color="tarefaSelecionada.dentro_sla ? 'green' : 'red'">
                  {{ tarefaSelecionada.dentro_sla ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
            </div>
          </div>

          <div class="card-sla">
            <div>
              <span class="title" v-if="dadosFichaTecnica.pco_tarefa?.finalized_at">
                {{ circuitoSelecionado.aging_dias_formatado || '-' }}
              </span>
              <span class="title" v-else>
                {{ circuitoSelecionado.data_entrada_backlog ? agingCircuito(circuitoSelecionado.data_entrada_backlog) :
                  circuitoSelecionado.aging_dias_formatado || '-' }}
              </span>
              <span class="sub-title">aging circuito</span>
            </div>
            <div>
              <span class="sla">
                SLA
                <v-icon
                  :color="`${(circuitoSelecionado.aging_dias_circuito_expurgo_cliente > circuitoSelecionado.prazo_tipo_circuito_sla) ? 'primary' : 'green'}`">
                  mdi-check-circle
                </v-icon>
              </span>
            </div>
          </div>

          <div class="card-sla">
            <div>
              <span class="title">
                {{ circuitoSelecionado.aging_dias_circuito_expurgo_cliente ?
                  circuitoSelecionado.aging_dias_circuito_expurgo_cliente + ' dias' : '-' }}
              </span>
              <span class="sub-title">aging circuito expurgo cliente</span>
            </div>
            <div>
              <span class="sla">
                SLA
                <v-icon
                  :color="`${(circuitoSelecionado.aging_dias_circuito_expurgo_cliente > circuitoSelecionado.prazo_tipo_circuito_sla) ? 'primary' : 'green'}`">
                  mdi-check-circle
                </v-icon>
              </span>
            </div>
          </div>

          <div class="card-sla">
            <div>
              <span class="title"
                v-if="(circuitoSelecionado.prazo_tipo_circuito_sla - circuitoSelecionado.aging_dias_circuito_expurgo_cliente) >= 0">
                {{ (circuitoSelecionado.prazo_tipo_circuito_sla -
                  circuitoSelecionado.aging_dias_circuito_expurgo_cliente) + ' dias' }}
              </span>
              <span class="title" v-else>Vencido</span>
              <span class="sub-title">SLA a vencer</span>
            </div>
            <div>
              <span class="sla">
                SLA
                <v-icon
                  :color="`${(circuitoSelecionado.prazo_tipo_circuito_sla - circuitoSelecionado.aging_dias_circuito_expurgo_cliente) < 0 ? 'primary' : 'green'}`">
                  mdi-check-circle
                </v-icon>
              </span>
            </div>
          </div>
        </v-card>
      </div>

      <!-- ORIGINAL (SGP) -->
      <!-- <AbaComponent
      class="mt-5"
      :circuito="dadosFichaTecnica"
      :adocao="dadosAdocao"
      :saip="dadosSaipPcoCircuito"
      :sgap="dadosSgapPcoCircuito || {}"
      :wf1="dadosWf1PcoCircuito || {}"
    /> -->

      <AbaComponent class="mt-5" :circuito="dadosFichaTecnica" />

      <div class="macro-processos-timeline pl-5 pr-5">
        <div class="box" v-for="(box, index) in timelineMacroprocesso" :key="index">
          <div :class="`box-line ${['completed'].includes(box.status) ? 'primary' : ''}`"></div>
          <div class="box-content">
            <span>{{ box.title }}</span>
            <div :class="`circulo
            ${['completed'].includes(box.status) ? 'circulo-completed' : ''}
            ${['stoped'].includes(box.status) ? 'circulo-stoped' : ''}
            ${['current'].includes(box.status) ? 'circulo-current' : ''}
            ${['incomplete'].includes(box.status) ? 'circulo-incomplete' : ''}
          `">
              <SGPIconComponent v-if="box.status === 'completed'" color="white">mdi-check</SGPIconComponent>
              <SGPIconComponent v-if="box.status === 'stoped'" color="white">mdi-backburger</SGPIconComponent>
            </div>
            <span class="font-size-14">{{ box.aging }}</span>
          </div>
        </div>
      </div>

      <!-- <AcoesTratativasComponent
      :dadosFichaTecnica="dadosFichaTecnica"
      @atualizaFormularioDinamico="atualizaHistorico"
      :abrirModalTratativas="mostrarModalTratativas"
      :key="mostrarModalTratativas"
    /> -->

      <v-expansion-panels v-model="blocoPanels" :readonly="true" flat class="mt-5" v-if="hasBloco">
        <v-expansion-panel>
          <v-expansion-panel-header class="display-flex pl-1 pr-3" style="border-bottom: solid 1px #eee;" hide-actions>
            <div class="row">
              <div class="col-md-10">
                <h5 class="black--text" @click="expansionPanelOpenCloseControl()">
                  <i class="aberto v-icon notranslate mdi mdi-chevron-down theme--light primary--text"></i>
                  <i class="fechado v-icon notranslate mdi mdi-chevron-right theme--light primary--text"></i>
                  Informações do Bloco: Nº {{ dadosFichaTecnica.pco_tarefa.ctrl_bloco_id }}
                </h5>
              </div>
              <div class="col-md-2 text-right">
                <SGPFormBotaoComponent small class="ml-2" @click="excluindoBloco">
                  <v-icon color="white" small>mdi-trash-can-outline</v-icon>
                  <span>Excluir Bloco</span>
                </SGPFormBotaoComponent>
              </div>
            </div>

          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <BlocoTableComponent :dadosFichaTecnica="dadosFichaTecnica"></BlocoTableComponent>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- <v-expansion-panels v-model="painelTarefasPercorridas" flat class="mt-5 white">
      <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
          <h5 class="black--text">
            <i class="aberto v-icon notranslate mdi mdi-chevron-down theme--light primary--text"></i>
            <i class="fechado v-icon notranslate mdi mdi-chevron-right theme--light primary--text"></i>
            Tarefas percorridas
          </h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pl-3 pr-3">
          <FlowTimelineComponent
            v-if="listaDeLogsPcoTarefas.data.length"
            :circuito="circuitoSelecionado"
            :items="listaDeLogsPcoTarefas"
            :pco_tarefa_atual="$route.params.pco_tarefa_id"
          />
          <div class="mb-5" v-else>
            <span class="primary--text">Nehuma tarefa encontrada</span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->

      <!-- <SGPLoadingComponent v-if="loadingFichaTecnica || buscandoAutomacao" /> -->

      <HistoricoComponent :tarefa="dadosFichaTecnica.pco_tarefa" :circuito="circuitoSelecionado"
        :historico="dadosHistoricoFichaTecnica">
      </HistoricoComponent>
    </div>

    <!-- INICIO MODAIS -->
    <!-- <ModalPcoCirAnotacaoComponent
      v-model="abrirModalAnotacao"
      v-if="abrirModalAnotacao"
      :pcoCircuitoId="circuitoSelecionado.id"
      :ctrlBlocoId="tarefaSelecionada.ctrl_bloco_id"
    /> -->

    <!-- <ModalPcoCirAdocaoComponent
      v-model="abrirModalAdocao"
      v-if="abrirModalAdocao"
      :pcoCircuitoId="circuitoSelecionado.id"
    /> -->

    <!-- <TratativasSemTratamentoComponent
      @fecharModalAtualizacao="fecharModalSemTratamento"
      :pco_tarefa_id="dadosFichaTecnica.pco_tarefa_id"
      :pco_circuito="circuitoSelecionado"
      v-if="listaDeTratativasSemTratamento.length && abrirModalSemTratamento"
      @tratativaAtualizacaoPayloadEmit="forceComponentUpdate"
      @conteudoFormularioDinamicoEmit="conteudoFormulario"
    /> -->

    <!-- <ChecklistPreparacaoAtivacaoModal
      v-if="abrirModalChecklistAgendamento"
      :circuito="circuitoSelecionado"
      @fecharModal="abrirModalChecklistAgendamento = false"
    ></ChecklistPreparacaoAtivacaoModal> -->

    <!-- <SGPModalComponent
      v-model="abrirModalMulta"
      tamanho="sm"
      titulo="Aviso de multa"
      :mostrarFooter="false"
      v-if="abrirModalMulta"
      @sgpModalFechar="abrirModalMulta = false"
    >
      <p>Veja abaixo os detalhes da multa:</p>
      <h5>Data Compromisso Cliente: {{ circuitoSelecionado.data_prometida | formataDataPrometida  }}</h5>
      <h5>Observações: {{ circuitoSelecionado.obs_multa || '-' }}</h5>
    </SGPModalComponent> -->

    <!-- <SGPModalComponent
      v-model="abrirSolicitacaoMobilidade"
      tamanho="sm"
      titulo="Solicitação de mobilidade"
      :mostrarFooter="false"
      v-if="!abrirModalMulta && abrirSolicitacaoMobilidade"
      @sgpModalFechar="abrirSolicitacaoMobilidade = false"
    >
      <p><strong>Descrição:</strong><br> {{ circuitoSelecionado.desc_solicitacao_mob }}</p>
      <p><strong>Tarefa para envio:</strong><br> {{ circuitoSelecionado.tarefa_solicitacao_mob }}</p>
    </SGPModalComponent> -->

    <!-- <SGPModalComponent
      v-model="abrirModalClientesContatos"
      tamanho="xl"
      titulo="Contatos do cliente"
      :mostrarFooter="false"
      @sgpModalFechar="abrirModalClientesContatos = false"
      v-if="abrirModalClientesContatos"
    >
      <p>Utilize a busca abaixo para localizar os contatos do cliente desejado:</p>

      <CtrlStar21ClientesContatosPage
        is_modal
        :ctrlStar21ClienteId="circuitoSelecionado.ctrl_star21_cliente_id"
      />
    </SGPModalComponent> -->

    <SGPModalComponent v-model="abrirModalProjeto" tamanho="xl" titulo="Projeto" :mostrarFooter="false"
      v-if="abrirModalProjeto" @sgpModalFechar="abrirModalProjeto = false">
      <DadosProjetoComponent :projeto="circuitoSelecionado.ctrl_projeto" :modal="false" :fichatecnica="true" />
    </SGPModalComponent>

    <!-- <SGPModalImagemComponent
      v-if="abrirModalImage"
      :titulo="dadosFichaTecnica.pco_tarefa.ctrl_tarefa.tarefa"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
      :url="dadosFichaTecnica.pco_tarefa.ctrl_tarefa.url_file_processo"
    >
    </SGPModalImagemComponent> -->

    <!-- <div>
      <SGPConfirmacaoDelecaoComponent
          v-if="abrirModalDesfazerBlocoInteiro"
          @sgpCancelarDelecaoEmit="cancelarDesfazerBloco()"
          @sgpConfirmarDelecaoEmit="confirmarDesfazerBloco()"
          titulo="Atenção:"
          subtitulo="Tem certeza que deseja desfazer o bloco inteiro?"
      />
    </div> -->

    <!-- <SGPModalComponent
      v-model="abrirModalOrdemServico"
      tamanho="xl"
      titulo="Ordem de Serviço"
      :mostrarFooter="false"
      @sgpModalFechar="abrirModalOrdemServico = false"
      v-if="abrirModalOrdemServico"
    >
      <OrdemDeServicoPage
        :modosDePara="parametrosModos"
      />
    </SGPModalComponent> -->


    <!-- <ModalWf1Component
      v-if="abrirModalWf1"
      v-model="abrirModalWf1"
      :pcoCircuito="circuitoSelecionado"
     /> -->

    <!-- <SGPModalComponent
      v-model="abrirModalConsulta"
      tamanho="xl"
      titulo="Consultas"
      :mostrarFooter="false"
      @sgpModalFechar="abrirModalConsulta = false"
      v-if="abrirModalConsulta"
    >
      <SGPTabsMenuHorizontalComponent
        :itemsTabs="itemsTabs"
        :propsPage="propsPage"
      />
    </SGPModalComponent> -->

    <!-- <v-btn
      color="orange"
      v-b-tooltip.left
      title="Atualização"
      style="z-index: 99999999; margin-bottom: 55px;"
      fab
      fixed
      dark
      right
      small
      bottom
      v-if="mostrarBotaoMaximizarAtualizacao"
      @click="abrirModalSemTratamento = !abrirModalSemTratamento"
    >
      <v-icon>mdi-autorenew</v-icon>
    </v-btn> -->

    <!-- <div>
      <v-btn
        small
        v-b-tooltip.left
        title="WF1"
        v-if="mostrarBotaoMaximizarWf1"
        color="primary"
        style="z-index: 99999999;"
        fab
        dark
        fixed
        bottom
        right
        class="margin-bottom-100"
        @click="abrirModalWf1 = !abrirModalWf1"
      >
        <v-icon>mdi-calendar-edit-outline</v-icon>
      </v-btn>

      <v-btn
        small
        v-b-tooltip.left
        title="Anotações"
        v-if="mostrarBotaoMaximizarAnotacoes"
        color="primary"
        style="z-index: 99999999;"
        fab
        dark
        fixed
        bottom
        right
        class="margin-bottom-60"
        @click="abrirModalAnotacao = !abrirModalAnotacao"
      >
        <v-icon>mdi-format-list-checks</v-icon>
      </v-btn>
    </div>
     -->
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { recuperarCookie, removerCookie } from '@/common/boot/CookiesHandler.js';
// import ModalPcoCirAnotacaoComponent from '@/modules/sgp/pco-circuito-anotacoes/components/ModalPcoCirAnotacaoComponent'
//import ModalPcoCirAdocaoComponent from '@/modules/sgp/pco-circuito-adocao/components/ModalPcoCirAdocaoComponent'
// import TratativasSemTratamentoComponent from '../components/TratativasSemTratamentoComponent'
// import ChecklistPreparacaoAtivacaoModal from '@/modules/sgp/checklist-agendamento/components/ChecklistPreparacaoAtivacaoModal'
// import SGPInfoCardComponent from '../components/nova_ficha/SGPInfoCardComponent.vue';
// import BlocoTableComponent from '../components/nova_ficha/BlocoTableComponent.vue';
// import FlowTimelineComponent from '../components/nova_ficha/FlowTimelineComponent.vue';
import HistoricoComponent from '../components/nova_ficha/HistoricoComponent.vue'

import AbaComponent from '../components/nova_ficha/abas/AbaComponent.vue'
import moment from 'moment';
// import AcoesTratativasComponent from '../components/nova_ficha/AcoesTratativasComponent.vue'
// import EventBus from '@/common/helpers/EventBus'
// import CtrlStar21ClientesContatosPage from '@/modules/sgp/ctrl-star21-clientes-contatos/pages/CtrlStar21ClientesContatosPage'
// import OrdemDeServicoPage from '@/modules/sgp/modos/pages/OrdemDeServicoPage.vue'
// import DadosProjetoComponent from '@/modules/sgp/projetos/components/DadosProjetoComponent'
// import SGPTabsMenuHorizontalComponent from '../../../../common/sgp-components/SGPOrdemServico/SGPTabsMenuHorizontalComponent.vue';
// import SGPLoadingComponent from '@/common/sgp-components/SGPLoadingComponent.vue'
// import ModalWf1Component from '@/modules/sgp/pco-circuito-wf1/components/ModalWf1Component.vue'

export default {
  name: "FichaTecnicaWorkflowPage",

  components: {
    // ModalPcoCirAnotacaoComponent,
    //ModalPcoCirAdocaoComponent,
    // TratativasSemTratamentoComponent,
    // ChecklistPreparacaoAtivacaoModal,
    // SGPInfoCardComponent,
    // BlocoTableComponent,
    // FlowTimelineComponent,
    HistoricoComponent,
    AbaComponent,
    // AcoesTratativasComponent,
    // CtrlStar21ClientesContatosPage,
    // OrdemDeServicoPage,
    // DadosProjetoComponent,
    // SGPLoadingComponent,
    // SGPTabsMenuHorizontalComponent,
    // ModalWf1Component
  },

  data() {
    return {
      blocoPanels: 0,
      // painelTarefasPercorridas: 0,
      // formularioId: '',
      // atualizarTela: false,
      // mostrarTabsTarefas: false,
      // tarefaEmAtendimento: {},
      // listaDeTratamentos: [],
      tarefaSelecionada: {},
      // abrirModalImage: false,
      // abrirModalAnotacao: false,
      circuitoSelecionado: {},
      abrirModalSemTratamento: false,
      // abrirModalWf1: false,
      alertaSolicitacaoCancelamento: true,
      // abrirModalMulta: false,
      // abrirModalClientesContatos: false,
      abrirModalProjeto: false,
      // abrirSolicitacaoMobilidade: false,
      // abrirModalChecklistAgendamento: false,
      ficha: {},
      abrirModalDesfazerBlocoInteiro: false,
      // abrirModalOrdemServico: false,
      // abrirModalConsulta: false,
      // mostrarBotaoMaximizarAnotacoes: false,
      // mostrarBotaoMaximizarAtualizacao: false,
      mostrarModalTratativas: false,
      // mostrarBotaoMaximizarWf1: false,
    }
  },

  async created() {
    localStorage.removeItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO)
    removerCookie("formulario_anotacao_minimizado");
    removerCookie("formulario_wf1_minimizado");

    await this.buscarDadosFichaTecnica(this.$route.params.pco_workflow_id);


    // if (this.dadosFichaTecnica.pco_tarefa) {
    //   this.ficha = this.dadosFichaTecnica
    //   this.circuitoSelecionado = this.dadosFichaTecnica.pco_tarefa.pco_circuito

    //   const filtros = {
    //     pco_tarefa_id: [parseInt(this.$route.params.pco_tarefa_id)],
    //     pco_circuito_id: this.dadosFichaTecnica.pco_tarefa.pco_circuito_id,
    //     exibir_historico_completo: false,
    //     tarefa_finalizada: this.dadosFichaTecnica.pco_tarefa.finalized_at
    //   }
    //   this.buscarDadosHistoricoFichaTecnica(filtros);
    // }


    this.getTarefaSelecionada();
    // this.listarPcoCircuitoAnotacoes(this.circuitoSelecionado.id)
    // await this.getDadosSaipPcoCircuito(this.circuitoSelecionado.id)
    // await this.getDadosSgaPlusPcoCircuito(this.circuitoSelecionado.id)
    // await this.getDadosWf1PcoCircuito(this.circuitoSelecionado.id)
    // this.listarCircuitoPcoTarefasLog({ pco_circuito_id : this.circuitoSelecionado.id })

    // this.gerenciadorDeCookiesDaMulta()

    if (this.circuitoSelecionado.pco_circuito_adocao_id) {
      await this.listaDadosFichaTecnicaAdocao(parseInt(this.circuitoSelecionado.pco_circuito_adocao_id))
    }

    // this.listarProcessos();

    const formulario = recuperarCookie('formulario_anotacao_minimizado')

    if (formulario) {
      this.formulario = formulario
    }

    const formularioWf1 = recuperarCookie('formulario_wf1_minimizado')
    if (formularioWf1) {
      this.formulario = formularioWf1
    }

    // EventBus.$on('abrirModalClientesContatos', this.handlerAbrirModalClientesContatos)
  },

  // destroyed () {
  //   EventBus.$off('abrirModalClientesContatos', this.abrirModalClientesContatos = false)
  // },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'loadingFichaTecnica',
      'dadosFichaTecnica',
      'dadosHistoricoFichaTecnica',
      'listaDeLogsPcoTarefas',
      'dadosAdocao'
    ]),

    // ...mapGetters('pcoCircuitoSaip', [
    //   'dadosSaipPcoCircuito'
    // ]),

    ...mapGetters('ctrlTratativas', [
      'listaDeTratativasSemTratamento'
    ]),

    // ...mapGetters('pcoCircuitoAnotacoes', [
    //   'listaDePcoCircuitoAnotacoes',
    // ]),

    // ...mapGetters('processos', [
    //   'listaDeProcessos'
    // ]),

    ...mapGetters('automacao', [
      'buscandoAutomacao'
    ]),

    // ...mapGetters('pcoCircuitoWf1', [
    //   'dadosWf1PcoCircuito'
    // ]),

    itemsTabs() {
      const tabs = [
        { key: 'SAIP', label: 'SAIP', pathComponent: 'modules/workflow/shared/automacao/components/ConsultaSaipComponent' },
        { key: 'SAPWEB', label: 'SAPWEB', pathComponent: 'modules/workflow/shared/automacao/components/ConsultaSapWebComponent' },
        { key: 'CLA', label: 'CLA', pathComponent: 'modules/workflow/shared/automacao/components/ConsultaClaComponent' },
        { key: 'SEV', label: 'SEV', pathComponent: 'modules/workflow/shared/automacao/components/ConsultaSevComponent' },
        { key: 'CPE ID', label: 'CPE ID', pathComponent: 'modules/workflow/shared/automacao/components/ConsultaEquipamentoComponent' },
        { key: 'WF1', label: 'WF1', pathComponent: 'modules/workflow/shared/automacao/components/ConsultaWf1Component' },
      ];
      return tabs;
    },

    propsPage() {
      const props = {
        saip: null,
        sapweb: null,
        cla: null,
        sev: null,
        cpeid: null,
        wf1: null
      }

      if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.terminal != null
        && this.dadosFichaTecnica.pco_tarefa.pco_circuito.terminal != 0) {
        props.saip = this.dadosFichaTecnica.pco_tarefa.pco_circuito.terminal;
        props.cpeid = this.dadosFichaTecnica.pco_tarefa.pco_circuito.terminal;
      } else {
        props.saip = this.dadosFichaTecnica.pco_tarefa.pco_circuito.designacao;
        props.cpeid = this.dadosFichaTecnica.pco_tarefa.pco_circuito.designacao;
      }

      if (this.dadosFichaTecnica.pco_tarefa.pco_circuito != undefined
        && this.dadosFichaTecnica.pco_tarefa.pco_circuito != null) {
        if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.codigo_sap_web != "0") {
          props.sapweb = this.dadosFichaTecnica.pco_tarefa.pco_circuito.codigo_sap_web;
        }
      }

      if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.pco_checklist_agendamento != undefined
        && this.dadosFichaTecnica.pco_tarefa.pco_circuito.pco_checklist_agendamento != null) {
        if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.pco_checklist_agendamento.sol_id_cla != null) {
          props.cla = this.dadosFichaTecnica.pco_tarefa.pco_circuito.pco_checklist_agendamento.sol_id_cla;
        }
      }

      if (this.dadosFichaTecnica.pco_tarefa.pco_circuito != undefined
        && this.dadosFichaTecnica.pco_tarefa.pco_circuito != null) {
        if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.numero_sev != null) {
          props.sev = this.dadosFichaTecnica.pco_tarefa.pco_circuito.numero_sev;
        }
      }

      // if (this.dadosFichaTecnica.pco_tarefa.pco_circuito.fichas_tecnicas.length > 0) {
      //   const ficha = JSON.parse(this.dadosFichaTecnica.pco_tarefa.pco_circuito.fichas_tecnicas[0].ficha_tecnica);

      //   if (ficha.construcao != null) {
      //     if (ficha.construcao.os_const != undefined || null) {
      //       props.wf1 = (ficha.construcao.os_const.value != "") ? ficha.construcao.os_const.value : null;
      //     }
      //   }
      // }

      return props;
    },

    // listaDeMacroProcessosFiltrados () {
    //   if(this.listaDeProcessos.length) {
    //     return this.listaDeProcessos.filter(processo => processo.ctrl_processo_id == null)
    //     .sort(function (a, b) {
    //       if (a.ordem > b.ordem) {
    //         return 1;
    //       }
    //       if (a.ordem < b.ordem) {
    //         return -1;
    //       }
    //       return 0;
    //     });
    //   }
    //   return []
    // },

    listaDeTratametosNormalizada() {
      return []
    },

    timelineMacroprocesso() {
      const workflow = this.dadosFichaTecnica.pco_workflow;
      if (!workflow || !workflow.processos?.length) return [];

      const ordem = proc => proc.ctrl_processo?.ordem ?? Number.MAX_SAFE_INTEGER;

      return [...workflow.processos]
        .sort((a, b) => ordem(a) - ordem(b))
        .map(proc => ({
          title: proc.ctrl_processo?.processo || '-',
          aging: '-',        // placeholder
          status: 'incomplete' // placeholder
        }));
    },

    parametrosModos() {
      return {
        pcoTarefa: this.dadosFichaTecnica.pco_tarefa,
        pcoCircuitoSelecionado: this.circuitoSelecionado
      }
    },

    // getAgingTarefa () {
    //   if (this.tarefaSelecionada) {
    //     let tarefa = this.tarefaSelecionada

    //     if (tarefa.status_atual.pco_macro_status) {
    //       return tarefa.status_atual.pco_macro_status.aging_dias_formatado
    //     } else {
    //       if (tarefa.pco_status.length === 3) {
    //         let aging = tarefa.pco_status.map(s => s.aging_dias)
    //         return `${aging.reduce((a,b)=>a+b)} dias`;
    //       }

    //       return tarefa.pco_status[0].aging_dias_formatado
    //     }
    //   }

    //   return ''
    // }
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'salvarDadosFormulario',
      'buscarDadosFichaTecnica',
      'limparFichaTecnica',
      'buscarDadosHistoricoFichaTecnica',
      // 'listarCircuitoPcoTarefasLog',
      'listaDadosFichaTecnicaAdocao',
      'desfazerBloco'
    ]),

    ...mapActions('ctrlTratativas', [
      'listarTratativasSemTratamento'
    ]),

    ...mapActions('circuitos', ['recuperarCircuitoPorCodigoCir']),

    // ...mapActions('pcoCircuitoAnotacoes', [
    //   'listarPcoCircuitoAnotacoes'
    // ]),

    // ...mapActions('processos', [
    //   'listarProcessos'
    // ]),

    // ...mapActions('pcoCircuitoSaip', [
    //   'getDadosSaipPcoCircuito'
    // ]),

    // ...mapActions('pcoCircuitoSgap', [
    //   'getDadosSgaPlusPcoCircuito'
    // ]),

    // ...mapActions('pcoCircuitoWf1', [
    //   'getDadosWf1PcoCircuito'
    // ]),

    expansionPanelOpenCloseControl() {
      this.blocoPanels = this.blocoPanels == 0 ? 1 : 0
    },

    // handlerAbrirModalClientesContatos () {
    //   this.abrirModalClientesContatos = true
    // },

    atualizaHistorico() {
      this.listaDadosTratamento();
    },

    // fecharModal () {
    //   this.abrirModalImage = false;
    // },

    // fecharModalModos () {
    //   this.abrirModalOrdemServico = false
    // },

    fecharModalWf1() {
      this.abrirModalWf1 = false
    },

    // gerenciadorDeCookiesDaMulta() {
    //   const existeCookieMulta = recuperarCookie(`multa_${this.$route.params.pco_tarefa_id}`)

    //   if (existeCookieMulta) {
    //     this.abrirModalMulta = false
    //     return
    //   }

    //   if (this.circuitoSelecionado.possui_multa) {
    //     this.abrirModalMulta = true
    //     this.$cookies.set(
    //       `multa_${this.$route.params.pco_tarefa_id}`, // nome
    //       true, // valor
    //       '30d' // tempo de expiração 30 dias
    //     )
    //   }
    // },

    getLinkFilaTarefas() {
      var link = '';

      link = '/workflow/filas-tarefas/'
      link += this.dadosFichaTecnica.pco_tarefa?.ctrl_tarefa.id

      return link == '' ? '#' : link;
    },

    getTarefaSelecionada() {
      this.tarefaSelecionada = this.dadosFichaTecnica.pco_tarefa
    },
    corMultaVencida(dataMulta) {
      const cor =
        moment(dataMulta).format('YYYYMMDD') <= moment(Date().now).format('YYYYMMDD') ? 'red' : 'orange'
      return cor
    },

    // excluindoBloco() {
    //   this.abrirModalDesfazerBlocoInteiro = true;
    // },

    // cancelarDesfazerBloco () {
    //   this.abrirModalDesfazerBlocoInteiro = false;
    // },

    // async confirmarDesfazerBloco() {
    //   await this.desfazerBloco({id: this.dadosFichaTecnica.tarefas_bloco[0].ctrl_bloco_id});
    //   this.buscarDadosFichaTecnica(this.$route.params.pco_tarefa_id);
    // },

    async forceComponentUpdate() {
      this.abrirModalSemTratamento = false
      if (this.$route.params?.pco_tarefa_id) {
        await this.buscarDadosFichaTecnica(this.$route.params.pco_tarefa_id);
      }
      this.circuitoSelecionado = this.dadosFichaTecnica.pco_tarefa.pco_circuito
      this.alertaSolicitacaoCancelamento = false
    },

    async fecharModalSemTratamento() {
      this.abrirModalSemTratamento = false
    },

    agingCircuito(val) {
      let now = moment()
      let entradaBacklog = moment(val)
      let diferencaEmDias = moment(now).diff(entradaBacklog, 'days')
      return `${diferencaEmDias} ${diferencaEmDias != 1 ? 'dias' : 'dia'} `
    }
  },
  filters: {
    formataDataPrometida(val) {
      return moment(val).format('DD/MM/YYYY')
    }
  },

  watch: {
    // abrirModalAnotacao (val) {
    //   // toda vez que houver uma abertura ou fechamento do modal de anotações
    //   // deve ser feita uma verificação se esse modal pode ser maximizado e hidratado
    //   // com os dados mantidos em cache dentro da variavel ('formulario_anotacao_minimizado')
    //   const formulario = recuperarCookie('formulario_anotacao_minimizado')
    //   if (formulario) {
    //     this.mostrarBotaoMaximizarAnotacoes = !val
    //   }
    // },

    abrirModalSemTratamento(val) {
      const formulario = recuperarCookie("formulario_atualizacao_minimizado")
      if (formulario) {
        this.mostrarBotaoMaximizarAtualizacao = !val
      }
    },

    // abrirModalWf1 (val) {
    //   // toda vez que houver uma abertura ou fechamento do modal de anotações
    //   // deve ser feita uma verificação se esse modal pode ser maximizado e hidratado
    //   // com os dados mantidos em cache dentro da variavel ('formulario_anotacao_minimizado')
    //   const formulario = recuperarCookie('formulario_wf1_minimizado')
    //   if (formulario) {
    //     this.mostrarBotaoMaximizarWf1 = !val
    //   }
    // }
  }
}
</script>

<style lang="scss">
$primary: #E3262E;

.v-application.black {
  background-color: $primary !important;
  border-color: $primary !important;
  color: #fff !important;
}

.content-header {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  gap: 8px;

  .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    width: 97%;
    gap: 8px;

    .left-title {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
    }

    .right-title {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: 500;
    font-family: Roboto;
    color: #666;
  }

  .buttons-container {
    display: flex;
    gap: 90;
  }
}

.content-body {
  padding: 0 20px;
}

.card-infor-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.card-sla {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-right: solid 1px #ddd;

  .title {
    color: $primary;
  }

  .sub-title {
    font-size: 12px;
    font-weight: 500;
    color: #666;
  }

  span {
    display: block;
  }

  .sla {
    color: #aaa;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &:last-child {
    border: none;
  }
}

.text-capitalize {
  text-transform: capitalize;
}

.alerta-cancelamento {
  display: flex;
  padding: 10px;
  background: $primary;
  border-radius: 8px;
  animation-name: change;
  animation-duration: 2.8s;
  animation-iteration-count: infinite;
}

@keyframes change {
  0% {
    background: #B41E13;
  }

  50% {
    background: #FB9C2D;
  }

  100% {
    background: #B41E13;
  }
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background: transparent !important;
}

.v-expansion-panel-header,
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-expansion-panel:before {
  box-shadow: none !important;
}

.v-expansion-panel-header .aberto {
  transition: display 5s linear;
  display: none !important;
}

.v-expansion-panel-header .fechado {
  display: inline !important;
}

.v-expansion-panel-header--active .aberto {
  transition: display 5s linear;
  display: inline !important;
}

.v-expansion-panel-header--active .fechado {
  display: none !important;
}

.v-application--is-ltr .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse):before {
  left: calc(10.32% - 1px);
  right: auto;
}

.macro-processos-timeline {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  height: 100px;
  margin-top: 30px;

  div.box {
    width: 100%;
    align-items: center;
    justify-content: center;
    position: relative;

    .box-line {
      content: "";
      height: 10px;
      width: 100%;
      background: #ccc;
      position: absolute;
      top: 50%;
      z-index: 1;
      margin-top: -5px;
      left: 0;
    }

    &:last-child {
      width: 40px;
    }

    .box-content {
      display: flex;
      flex-direction: column;
      max-width: 200px;
      align-items: right;
      width: 200px;
      text-align: center;

      &:first-child {
        text-align: left;
      }

      span {
        position: relative;
        max-width: 200px;
        display: block;
        left: -74px;
        font-weight: 500;
        color: $primary;
      }
    }

    div.circulo {
      position: inherit;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 3px solid $primary;
      background: #fff;
      z-index: 3;
    }

    div.circulo-completed {
      background: $primary;
    }

    div.circulo-stoped {
      border-color: #FB9C2D;
      background: #FB9C2D;
    }

    div.circulo-current {
      border-color: $primary;
      background: #fff;
    }

    div.circulo-incomplete {
      border-color: #ccc;
      background: #ccc;
    }
  }
}
</style>
